<!-- 线性图表 -->
<template>
  <div class="echarts">
    <div ref="echartNode" style="height:100%;"></div>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  export default {
    name: 'LineChart',
    components: {},
    props: {
      echartData: {
        type: Object,
        default () {
          return null
        }
      },
    },
    data() {
      return {
        chartOptions: {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: '5%',
            left: 'center'
          },
          color: ['#60B7DC', '#EFDB1C'],
          series: [{
            name: '',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [{
                value: 0,
                name:'课程浏览'
              },
              {
                value: 0,
                name:'商品浏览'
              },
            ]
          }]
        },
        echarts: null,
        a: 'ge'
      }
    },
    created() {},
    mounted() {
      this.calcEcharts()
    },
    methods: {
      calcEcharts() {
        if (!this.echarts) {
          this.echarts = echarts.init(this.$refs.echartNode);
          // 添加窗口改变监听
          this.echarts._resize = () => {
            this.echarts.resize();
          };
          window.addEventListener("resize", this.echarts._resize);
        }
        // this.chartOptions.legend.data = this.echartData.yAxisData.map(it => it.name);
        // this.chartOptions.xAxis.data = this.echartData.xAxisData;
        this.chartOptions.series[0].data[0].value = this.echartData.kecheng;
        // this.chartOptions.series[0].data[0].name = `课程浏览：${this.echartData.kecheng+this.echartData.shangpin==0?'0%':(this.echartData.kecheng/(this.echartData.kecheng+this.echartData.shangpin)*100+'%')}`;
        // this.chartOptions.series[0].data[0].name = `课程浏览`;
        this.chartOptions.series[0].data[1].value = this.echartData.shangpin;
        // this.chartOptions.series[0].data[1].name = `商品浏览`;
        this.refreshChart();
      },
      refreshChart() {
        let myChart = this.echarts;
        if (!this.echarts) {
          myChart = echarts.init(this.$refs.echarts);
        }
        myChart.clear();
        myChart.setOption(this.chartOptions);
        console.log(this.chartOptions)
      }
    },
    watch: {
      echartData(newVal) {
        this.calcEcharts()
      }
    }
  }
</script>
<style lang='scss' scoped>
  .echarts {
    width: 100%;
    height: 400px;
  }
</style>
